module.exports = __webpack_public_path__ + "img/recruitment2.b385c77c.png";